const messages = {
  statusCodes: [
    {
      code: 308,
      text: 'Search for your network name.',
      type: 'info',
    },
    {
      code: 400,
      text: 'Choose a network.',
      type: 'info',
    },
    {
      code: 404,
      text: 'That network is unknown.',
      type: 'info',
    },
    {
      code: 412,
      contact: true,
      text: 'You\'ve entered a strange state.',
      type: 'info',
    },
    {
      code: 500,
      text: 'Server error. Please try again in a moment.',
      type: 'error',
    },
    {
      code: 502,
      text: 'Failed to fetch from network.',
      type: 'error',
    },
  ],
}

export default messages
